import { OptionsState } from 'src/app/models/user-options.model';

export class SetOptions {
  static readonly type = '[Options] Set Options';
  constructor(public options: Partial<OptionsState>) {}
}

export class SetTheme {
  static readonly type = '[Options] Set Theme';
  constructor(public theme: string) {}
}

export class SetActiveTheme {
  static readonly type = '[Options] Set Active Theme';
  constructor(public activeTheme: string) {}
}
